import { useEffect, useState } from 'react'
import { FlexColumn, FlexRow } from '@/atoms/FlexContainers'
import { CaptionMD, CaptionSM } from '@/atoms/Text'
import { useFrame } from '@/organisms/CollectiblesPlayer/FrameContext'
import { useUser } from '@/services/UserService'
import { useSafeRouter } from '@/utils/nextUtils/safe-router'
// import { Frame } from '@/types/codegen-federation'
import { Translate, useTranslate } from '@/utils/translate/translate-client'
import { MomentOwnershipAvatar } from '../MomentOwnershipAvatar'

function formatDate(isoDate: number) {
  const date = new Date(isoDate)
  return new Intl.DateTimeFormat('en-US', { month: 'long', day: 'numeric', year: 'numeric' }).format(date)
}

export default function FrameOwnerSection() {
  const { t } = useTranslate('watch')
  const frame = useFrame()
  const [displayName, setDisplayName] = useState<string>('')
  const [since, setSince] = useState<string>('')
  const [isFrameOwner, setIsFrameOwner] = useState<boolean>(false)
  const router = useSafeRouter()
  const user = useUser()

  useEffect(() => {
    if (frame?.user?.firstName && frame?.user?.lastName) {
      setDisplayName(`${frame?.user?.firstName} ${frame?.user?.lastName}`)
    }
    if (frame?.user?.firstName && !frame?.user?.lastName) {
      setDisplayName(`${frame?.user?.firstName}`)
    }
    if (!frame?.user?.firstName && frame?.user?.lastName) {
      setDisplayName(`${frame?.user?.lastName}`)
    }
    if (!frame?.user?.firstName && !frame?.user?.lastName) {
      setDisplayName('Anonymous')
    }
    if (frame?.nifty?.ownedSince) {
      setSince(formatDate(frame?.nifty?.ownedSince))
    }
  }, [frame, frame?.nifty?.ownedSince])

  useEffect(() => {
    if (user?.userId === frame?.user?.uuid) {
      setIsFrameOwner(true)
    }
  }, [user?.userId, frame?.user?.uuid])

  const toAccount = () => {
    if (isFrameOwner) router.push(`/account`)
  }

  if (!frame || !displayName) return null
  return (
    <div
      onClick={toAccount}
      className={`relative mb-6 w-full rounded-xl bg-core-gray-800 p-4 ${isFrameOwner ? 'cursor-pointer' : ''}`}
    >
      <CaptionSM color="core-gray-500" className="mb-2">
        <Translate i18nKey="frameOwner" t={t}>
          Frame Owner
        </Translate>
      </CaptionSM>
      <FlexRow>
        {frame?.user?.image && (
          <FlexRow className="pr-2">
            <MomentOwnershipAvatar className="pr-2" index={0} iconPosition="none" imageUrl={frame?.user?.image} />
          </FlexRow>
        )}
        <FlexColumn>
          <CaptionMD>{displayName}</CaptionMD>
          {since && (
            <CaptionSM>
              <Translate i18nKey="ownerSince" t={t} values={{ since }}>
                Owner since: {{ since }}
              </Translate>
            </CaptionSM>
          )}
        </FlexColumn>
      </FlexRow>
    </div>
  )
}
